import esContent from './preChat.es';

export default {
  ...esContent,
};
